export default "__VITE_ASSET__Dv3GrhtB__"